import { useTranslation } from "react-i18next";
import Container, { Direction, HorizontalAlign, VerticalAlign } from "../Container";
import styles from "./styles.module.scss";
import { ReactComponent as CallIcon } from "../../img/call.svg";
import { ReactComponent as MailIcon } from "../../img/mail.svg";
import { ReactComponent as LocIcon } from "../../img/location.svg";
import { useEffect, useState } from "react";

const Footer = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const { t } = useTranslation();

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize)
    };
  }, [setWidth]);

  return (
    <Container
      verticalAlign={VerticalAlign.Middle}
      horizontalAlign={HorizontalAlign.Left}
      gap={width > 500 ? 20 : 10}
      className={styles.footer}
    >
      <Container
        horizontalAlign={HorizontalAlign.Left}
        direction={width > 1200 ? Direction.Row : Direction.Column}
        spaceBetween={true}
        width={"100%"}
      >
        <Container
          direction={width > 800 ? Direction.Row : Direction.Column}
          gap={width > 800 ? 60 : 0}
          verticalAlign={VerticalAlign.Top}
          horizontalAlign={HorizontalAlign.Left}
        >
          <Container
            horizontalAlign={HorizontalAlign.Left}
            direction={width > 450 ? Direction.Row : Direction.Column}
            gap={width > 450 ? 60 : 0}
          >
            <Container direction={Direction.Row} verticalAlign={VerticalAlign.Top} gap={10}>
              <CallIcon className={styles.icon} />
              <Container width={120}>
                <p className={"m-0"}>+373 54-54-45</p>
              </Container>
            </Container>
            <Container direction={Direction.Row} verticalAlign={VerticalAlign.Top} gap={10}>
              <MailIcon className={styles.icon} />
              <p className={"m-0"}>info@kmm.md</p>
            </Container>
          </Container>
          <Container direction={Direction.Row} verticalAlign={VerticalAlign.Top} gap={10}>
            <LocIcon className={styles.icon} />
            <p className={"m-0"}>Str. C. Brancusi 124/1, Chisinau 2060</p>
          </Container>
        </Container>
        <Container horizontalAlign={HorizontalAlign.Left}>
          <p className="mt-3 mb-0">{t("footer")}</p>
        </Container>
      </Container>
    </Container>
  )
}

export default Footer;